import {createSlice} from '@reduxjs/toolkit';
import {httpPost} from '../../util/Rest';
import {DEBTOR} from '../../constants/MicroServiceConstants';
import {LEGAL_ACTION} from '../../constants/Lookup';

const initialData = {
  accountLegalData: {},
  dropDownData: {},
  accountLegalStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'AccountLegalActions',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    getAccountLegalData: (state, action) => {
      state.accountLegalData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postAccountLegalData: (state, action) => {
      state.accountLegalStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    putAccountLegalData: (state, action) => {
      state.accountLegalStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetLegalActionStatus: (state) => {
      state.accountLegalStatus = null;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload;
      state.isLoading = false;
      state.accountLegalStatus = null;
    },
    resetMsg: (state) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.response;
      state.isLoading = false;
      state.accountLegalStatus = null;
    },
  },
});

export default slice.reducer;

// Actions

const {
  postAccountLegalData,
  fetchDropDownData,
  resetLegalActionStatus,
  fetchStart,
  putAccountLegalData,
  fetchError,
  fetchSuccess,
  resetMsg,
} = slice.actions;

export const getLegalAction = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [LEGAL_ACTION],
      }),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postAccountLegal = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${DEBTOR}/save/legalaction`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postAccountLegalData(data));
          dispatch(fetchSuccess(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const putAccountLegal = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${DEBTOR}/update/legalaction`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(putAccountLegalData(data));
          dispatch(fetchSuccess(data));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetLegalAction = () => {
  return (dispatch) => {
    dispatch(resetLegalActionStatus());
  };
};

export const resetToast = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
